// extracted by mini-css-extract-plugin
export var leftAlign = "_2b-2";
export var popper = "_2b-0";
export var subtitle = "_2b-1";